import { combineReducers } from 'redux'

import AuthReducer from './auth.reducer'
import AppReducer from './app.reducer'
import StylesReducer from './styles.reducer'
// import storage from 'redux-persist/lib/storage'
// import { persistReducer } from 'redux-persist'
import ErrorReducer from './error.reducer'


const appReducer = combineReducers({
  auth: AuthReducer,
  app: AppReducer,
  styles: StylesReducer,
  errors: ErrorReducer
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};
export default rootReducer;
